import { SECTIONS } from './navConfig';

const FLAT_ITEMS = SECTIONS.flatMap((section) => section.items);

// Registers GrowthPilot's full route list with Shopify's native admin
// sidebar via the ui-nav-menu custom element (injected by the App Bridge CDN
// script — see index.html). Plain hrefs are intentional: App Bridge patches
// window.history itself, and react-router's BrowserHistory listens for that
// globally, so client-side routing keeps working without a manual onClick.
export function AppBridgeNavMenu() {
  return (
    <ui-nav-menu>
      {FLAT_ITEMS.map((item) => (
        <a key={item.path} href={item.path} rel={item.path === '/' ? 'home' : undefined}>
          {item.label}
        </a>
      ))}
    </ui-nav-menu>
  );
}
